
<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <h2>Assign Substitute User(s)
        <div class="float-right">
          <button class="btn btn-primary" type="submit" [disabled]="!readyToAssignUsers" (click)="assignUsers()">Assign Substitute Users</button>
        </div>
      </h2>
      <div class="row alert-container-block">
        <div class="col">
          <div class="alert alert-success" *ngIf="message">SUCCESS: {{message}}</div>
          <error [error]="error"></error>
        </div>
      </div>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left required">
        <p>Select substitute users:</p>
      </div>
      <div class="float-right" *ngIf="selectedUsers.length">
        <p>{{selectedUsers.length}} subsitute user(s) selected</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col table-card">
      <list-controls [showLimit]="false" [search]="searchTextUsers" [limit]="pageSizeUsers" [page]="currentPageUsers" [numPages]="maxPagesUsers" [totalCount]="users.length" (onChange)="onListControlsChangeUsers($event)">
        <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
        <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" href="javascript:void(0);" (click)="deselectAllUsers()">Deselect All</a><a class="dropdown-item" href="javascript:void(0);" (click)="selectAllUsers()">Select All</a><a class="dropdown-item" href="javascript:void(0);" (click)="selectAllVisibleUsers()">Select All In Search</a><a class="dropdown-item" href="javascript:void(0);" (click)="deselectAllVisibleUsers()">Deselect All In Search</a></div>
      </list-controls>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th></th>
            <th>User Name</th>
            <th>Email</th>
            <th>Roles</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of displayedUsers">
            <td>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" name="user-selection-checkbox-{{user.id}}" [(ngModel)]="user.selected" [disabled]="user.disabled || disableAll" (change)="updateReadyToAssignUsers()">
              </div>
            </td>
            <td>{{user.displayName}}</td>
            <td>{{user.emailAddress}}</td>
            <td>{{user.roles}}</td>
          </tr>
          <tr *ngIf="users.length === 0">
            <td colspan="4">
              <p class="text-center empty-table-message">There are no assignable users to display.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Select the projects to assign these user(s) to:</p>
      </div>
      <div class="float-right" *ngIf="selectedProjects.length">
        <p>{{selectedProjects.length}} project(s) selected to assign to substitute user(s)</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col table-card">
      <list-controls [showLimit]="false" [search]="searchTextProjects" [limit]="pageSizeProjects" [page]="currentPageProjects" [numPages]="maxPagesProjects" [totalCount]="projects.length" (onChange)="onListControlsChangeProjects($event)">
        <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
        <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" href="javascript:void(0);" (click)="deselectAllProjects()">Deselect All</a><a class="dropdown-item" href="javascript:void(0);" (click)="selectAllProjects()">Select All</a><a class="dropdown-item" href="javascript:void(0);" (click)="selectAllVisibleProjects()">Select All In Search</a><a class="dropdown-item" href="javascript:void(0);" (click)="deselectAllVisibleProjects()">Deselect All In Search</a></div>
      </list-controls>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th></th>
            <th>Project Name</th>
            <th>K2 Customer Name</th>
            <th>Country Name</th>
            <th>Geo Region</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let project of displayedProjects">
            <td>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" name="user-selection-checkbox-{{project.id}}" [(ngModel)]="project.selected" [disabled]="project.disabled || disableAll" (change)="updateReadyToAssignUsers()">
              </div>
            </td>
            <td>{{project.projectName}}</td>
            <td>{{project.k2CustomerName}}</td>
            <td>{{project.country}}</td>
            <td>{{project.geoRegion}}</td>
          </tr>
          <tr *ngIf="projects.length === 0">
            <td colspan="4">
              <p class="text-center empty-table-message">There are no assignable projects to display.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>